module.exports = {"pagination":{"DescribeServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetAttributeValues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/pricing-2017-10-15.paginators.json
// module id = 417
// module chunks = 1